var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeWidth: 1.5,
    d: "M12 .75c-2.024 0-3.898.505-5.62 1.518C4.653 3.282 3.282 4.653 2.268 6.38 1.255 8.102.75 9.976.75 12s.505 3.898 1.518 5.62c1.014 1.727 2.385 3.098 4.112 4.112C8.102 22.745 9.976 23.25 12 23.25s3.898-.505 5.62-1.518c1.727-1.014 3.098-2.385 4.112-4.112 1.013-1.722 1.518-3.596 1.518-5.62s-.505-3.898-1.518-5.62c-1.014-1.727-2.385-3.098-4.112-4.112C15.898 1.255 14.024.75 12 .75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M17.492 11.381L9.186 6.127c-.254-.17-.593-.17-.762 0-.17.17-.424.424-.424.678v10.509c0 .339.17.593.424.678.17.084.254.084.423.084.17 0 .34-.084.424-.254l8.305-5.254c.255-.085.424-.424.424-.678 0-.254-.254-.34-.508-.509zM9.61 15.958V8.246l6.017 3.813-6.017 3.899z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.948c1ff1e445b80f755c2bd5987fed9a.svg";
export { ForwardRef as ReactComponent };